import React from 'react';
import { Tabs, Button } from 'antd';
import Coupon from '../RewardsCoupon';
import NoteModal from '../NoteModal';
import { useContainer } from '../StoreProvider';
import styled from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';
import EfModal from '@/components/UI/Modal';
import { SuccessIcon, NoDataIcon } from '@/components/UI/svg/Ecocredits';
import getLocal from '@/app/utils/getLocal';

export type RewardsModalHandle = {
    show: () => void;
};

const RewardsModal = ({}, ref: React.ForwardedRef<RewardsModalHandle>) => {
    const { isMobile, useRouter, useLang } = useGlobal();
    const router = useRouter();
    const { couponList } = useContainer();
    const { locale } = getLocal();
    const { t } = useLang('membersstore');
    const [visible, setVisible] = React.useState(false);
    const [activeKey, setActiveKey] = React.useState('discount');
    const [currCoupon, setCurrCoupon] = React.useState<any>(null);
    const [currNotes, setCurrNotes] = React.useState<any>(null);

    const issuedModules = [{ key: 'discount', label: t('discount'), list: couponList }]?.filter((module) => module?.list?.length);

    React.useImperativeHandle(ref, () => ({
        show: () => setVisible(true),
    }));

    const linkMap: { [k: string]: string } = {
        '1635227277057232898': `/${locale}/ecocredits-day`,
        '1638383549539569666': 'https://us.ecoflow.com/products/outdoor-kit',
        '1638384706130059266': 'https://us.ecoflow.com/products/river-2-pro-portable-power-station',
        '1638385215599583234': 'https://us.ecoflow.com/products/delta-pro-portable-power-station',
        '1638386232449867777': 'https://ca.ecoflow.com/products/outdoor-kit',
        '1638386872819425281': 'https://ca.ecoflow.com/products/river-2-pro-portable-power-station',
        '1638387248596930562': 'https://ca.ecoflow.com/products/delta-pro-portable-power-station',
    };

    const shopNow = (coupon: any) => {
        const { thirdUrl, ruleType, discountId, jumpUrl } = coupon;
        if (ruleType === 'THIRD_COUPONS') {
            if (isMobile) {
                router.push(thirdUrl);
                return;
            }
            window.open(thirdUrl, '_blank');
            return;
        }

        let href: string | undefined = linkMap[discountId];
        // 读取配置的url
        if (jumpUrl) href = jumpUrl;
        if (href) {
            if (href.startsWith('http')) {
                setTimeout(() => window.open(href, '_blank'));
            } else {
                window.location.href = href;
            }
            return;
        }

        if (isMobile) {
            router.push(`https://${locale}.ecoflow.com`);
            return;
        }
        setTimeout(() => {
            window.open(`https://${locale}.ecoflow.com`, '_blank');
        });
    };

    const onClickRule = (rule: any) => {
        setCurrNotes(rule);
    };

    const onClickItem = (coupon: any) => {
        if (coupon?.useStatus !== 'UNUSED') return;
        if (coupon?.ruleType === 'FREE_PRODUCTS') return;
        setCurrCoupon(coupon);
    };

    return (
        <>
            <EfModal
                width={920}
                visible={visible}
                open={visible}
                className={styled.rewards_modal}
                getContainer={true}
                maskClosable={isMobile}
                centered={true}
                onCancel={() => setVisible(false)}
                style={{}}
            >
                <div className="content">
                    <div className="title">{t('banner.modal_reward.title')}</div>
                    <Tabs activeKey={activeKey} className={`rewards-tabs issued_tab`} onChange={setActiveKey} centered={isMobile}>
                        <Tabs.TabPane tab={t('issued_tab_name')} key="discount">
                            {!!issuedModules?.length ? (
                                issuedModules?.map((module) => (
                                    <div key={module.key} className="module-item">
                                        <h5 className="module_title">{module.label}</h5>
                                        <ul className="rule-list">
                                            {module.list?.map((coupon: any) => (
                                                <Coupon
                                                    key={coupon?.id}
                                                    className={`rule-item ${coupon?.useStatus}`}
                                                    coupon={coupon}
                                                    disabled={coupon.useStatus !== 'UNUSED'}
                                                    hideBtn
                                                    hideAmount={['THIRD_COUPONS', 'FREE_PRODUCTS'].includes(coupon?.ruleType)}
                                                    showJumpBtn={'THIRD_COUPONS' === coupon?.ruleType && module.list?.some((coupon: any) => !!coupon.useUrl)}
                                                    onViewsRules={onClickRule}
                                                    onClickCard={onClickItem}
                                                />
                                            ))}
                                        </ul>
                                    </div>
                                ))
                            ) : (
                                <div className="no-content">
                                    <div className="no-content-icon">
                                        <NoDataIcon />
                                    </div>
                                    <p className="no-content-note">{t('no_coupon_note')}</p>
                                </div>
                            )}
                        </Tabs.TabPane>
                    </Tabs>
                </div>
            </EfModal>
            <EfModal
                className={styled.efmodal}
                visible={!!currCoupon}
                zIndex={1200}
                onCancel={() => {
                    setCurrCoupon(null);
                }}
            >
                <div className="content">
                    <div className="m-icon">
                        <SuccessIcon />
                    </div>
                    <h5 className="m-title">{t('copy_desc')}</h5>

                    <Button onClick={() => shopNow(currCoupon)} className="m-btn">
                        {t('store')}
                    </Button>
                </div>
            </EfModal>
            <NoteModal currNotes={currNotes} setCurrNotes={setCurrNotes} disabledCoupon={currNotes?.useStatus !== 'UNUSED'} />
        </>
    );
};

export default React.forwardRef<RewardsModalHandle>(RewardsModal);
